/**
 * @generated SignedSource<<6f71e30a6f3ff9ae17bdb70469621c47>>
 * @relayHash 7da80c4186ab379cb41cda405bebee65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1

import type { ConcreteRequest } from 'relay-runtime';
export type TemplateMediaSessionDownloadQuery$variables = {
  collectionId?: string | null;
  spaceKey?: string | null;
  templateIds: ReadonlyArray<string | null>;
};
export type TemplateMediaSessionDownloadQuery$data = {
  readonly templateMediaSession: {
    readonly collections: ReadonlyArray<{
      readonly key: string | null;
      readonly value: string | null;
    } | null>;
    readonly configuration: {
      readonly clientId: string;
      readonly fileStoreUrl: string;
    };
    readonly downloadToken: {
      readonly duration: number | null;
      readonly value: string | null;
    };
  } | null;
};
export type TemplateMediaSessionDownloadQuery = {
  response: TemplateMediaSessionDownloadQuery$data;
  variables: TemplateMediaSessionDownloadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collectionId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateIds"
},
v3 = {
  "kind": "ScalarField",
  "name": "value"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "collectionId",
        "variableName": "collectionId"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      },
      {
        "kind": "Variable",
        "name": "templateIds",
        "variableName": "templateIds"
      }
    ],
    "concreteType": "TemplateMediaSession",
    "kind": "LinkedField",
    "name": "templateMediaSession",
    "plural": false,
    "selections": [
      {
        "concreteType": "MapOfStringToString",
        "kind": "LinkedField",
        "name": "collections",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "key"
          },
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "MediaConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "fileStoreUrl"
          },
          {
            "kind": "ScalarField",
            "name": "clientId"
          }
        ]
      },
      {
        "concreteType": "TemplateMediaToken",
        "kind": "LinkedField",
        "name": "downloadToken",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "duration"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TemplateMediaSessionDownloadQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TemplateMediaSessionDownloadQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "7da80c4186ab379cb41cda405bebee65",
    "id": "b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1",
    "metadata": {},
    "name": "TemplateMediaSessionDownloadQuery",
    "operationKind": "query",
    "text": "query TemplateMediaSessionDownloadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},downloadToken{value,duration}}}"
  }
};
})();

(node as any).hash = "cb69ec0c674b12c3415c2289771f970f";

export default node;
